import { Config } from "../../configurations/config";
export const Feedback_APIs = {

    GetAllFeedbacks_API: `${Config.server_url}${Config.api_prefix}/FeedBack/GetAllFeedBacksAsync`,
    GetAllEmpFeedbacks_API: `${Config.server_url}${Config.api_prefix}/FeedBack/GetAllEmployeesFeedBacksAsync`,
    CreateFeedback_API: `${Config.server_url}${Config.api_prefix}/Feedback/CreateFeedBackAsync`,
    GetFeedbackDetails_API: `${Config.server_url}${Config.api_prefix}/Feedback/GetFeedbackByIdAsync?id=`,
    EditFeedback_API: `${Config.server_url}${Config.api_prefix}/FeedBack/UpdateFeedBackAsync?id=`,
    EditAttachment_API: `${Config.server_url}${Config.api_prefix}/FeedBack/EditFeedbackByIdAsync?id=`,
    DeleteFeedback_API: `${Config.server_url}${Config.api_prefix}/Feedback/DeleteFeedbackAsync?feedbackId=`,
    FeedbackStatus_API : `${Config.server_url}${Config.api_prefix}/Feedback/UpdateFeedBacStatuskAsync?id=`

};